enum AuthEvents {
  SigninTap = 'signin_tap',
  ForgotPasswordTap = 'forgot_password_tap',
}

export default AuthEvents
